import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { LocationService } from 'services/location.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Customer } from '../../customer';
import { CustomerService } from '../customer.service';
import { ExportService } from '../../../../shared/services/export.service';
import { SettingsService } from '../../../../shared/services/settings.service';
import { Branch } from '../../branch';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ReportService } from '../../../../shared/services/report.service';
import {Utils} from '../../../../shared/utils';


@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss'],
  providers: [CustomerService, ReportService]
})
export class CustomerListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  subscriptions: Subscription[] = [];
  customers: Customer[] = [];

  allCity$: Observable<any[]>
  allCountry$: Observable<any[]>

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Name' },
    { name: 'contact_name', label: 'Contact' },
    { name: 'address', label: 'Address' },
    { name: 'location', label: 'Location' },
    { name: 'phone_number', label: 'Phone' },
    { name: 'email_address', label: 'e-Mail' },
    { name: 'branch', label: 'Branch' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  selectedCustomer: number = -1;
  allCustomers$: Customer[];
  allCities: any = {};
  allCountries: any = {};

  selectedBranch: string = 'ALL';
  allBranches$: Branch[];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _customerService: CustomerService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _locationService: LocationService,
    public _authService: AuthenticationService,
    private _reportService: ReportService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscriptions.push(this._customerService
      .getCustomers()
      .subscribe((customers: Customer[]) => {

        if (customers && Array.isArray(customers)) {
          this.customers = customers;
        } else {
          this.customers = [];
        }
        this.filteredData = this.customers;
        this.filteredTotal = this.customers.length;

        this._loadingService.resolve('loading');

        this.fillInBranches();

        this.filter();
      },
        error => {
          this._loadingService.resolve('loading');
        }));

    this.allCountry$ = this._locationService.getCountry();

    //Use user's branches instead
    //this.subscriptions.push(this._supplierService.getBranches()
    this.subscriptions.push(Observable.of(this._authService.getUserBranches())
      .subscribe((branches: Branch[]) => {
        this.allBranches$ = branches;
        // this.allBranches$.unshift(new Branch({
        //   id: -1, name: 'All'
        // }));
        this.selectedBranch = 'ALL';
      }));

    this.subscriptions.push(this._locationService.getCity()
      .subscribe((cities: any[]) => {
        cities.forEach(city => {
          this.allCities[city.id] = city;
        });

        // this._locationService.getCountry()
        //   .subscribe((countries: any[]) => {
        //     countries.forEach(country => {
        //       this.allCountries[country.id] = country;
        //     });
        //   });
      }));
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('customer')) {
      this._searchBox.value = this._settingsService.getSearchTerm('customer');
      this._searchBox.searchClicked();
    }
  }

  delete(): void {
    this._loadingService.register('loading');

    let deleteCustomersCalls = [];
    let selectedCustomers = this.selectedRows;
    let customerIds = [];

    selectedCustomers.forEach(br => {
      let customerId = br.id;

      customerIds.push(customerId);

      deleteCustomersCalls.push(
        this._customerService
          .deleteCustomer(customerId)
          .map((res: Response) => res)
      );
    });

    Observable.forkJoin(deleteCustomersCalls).subscribe(data => {
      this._dialogService.openAlert({
        message: 'Successfully deleted ' + (selectedCustomers.length > 1 ? 'multiple customers' : '') + ' customer!',
        title: 'Success',
      });

      this.customers = this.customers.filter((customer: Customer) => {
        return !~customerIds.indexOf(customer.id);
      });

      this.filter();

      this._loadingService.resolve('loading');
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  fillInBranches() {
    this.customers.forEach(
      (c: Customer) => {
        c.branch = JSON.parse(c['branch_list'] || '[]').map(b => b.code).join(',');
        /*/this._customerService.getOneCustomerBranches(c.id).subscribe(
          (r: { id: string, branches: Branch[] }) => {
            this.customers.find(
              (customer: Customer) => {
                return customer.id == c.id;
              }
            ).branch = r.branches.map(b => b.code).join(',');

            this.filter();
          }
        );*/
      }
    )
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
    ? TdDataTableSortingOrder.Descending
    : TdDataTableSortingOrder.Ascending;
    
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('customer', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.customers;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    if (this.selectedCustomer > -1) {
      let selectedCustomer: number = this.selectedCustomer;
      newData = newData.filter(data => {
        return data.customers && !!~data.customers.findIndex(br => {
          return selectedCustomer === br.id;
        });
      });
    }

    if (this.selectedBranch != 'ALL') {
      newData = newData.filter(data => { return data.branch.indexOf(this.selectedBranch) >= 0 });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('customer'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  overCreditLimitReport() {
    this._reportService.getCreditLimitReportInfo().subscribe(
      info => {
        if (info) {
          info = info.filter(
            i => {
              // Sort by date
              if (!i.credit_margin || !Array.isArray(i.credit_margin)) i.credit_margin = [];
              i.credit_margin = i.credit_margin.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? -1 : 1 });

              let credit: number;
              if (i.credit_margin.length > 0) {
                credit = i.credit_margin[0].margin;
              } else {
                credit = 0;
              }

              i.credit = credit;

              return (Number.parseFloat((credit || 0) + '') - (Number.parseFloat(i.invoices_outstanding || '0') + Number.parseFloat(i.orders_outstanding || '0'))) < 0
            }
          );

          this._reportService.overCreditLimitReport(info);
        }
      }
    );
  }

  creditManagementReport() {
    this._reportService.getCreditManagementReportInfo().subscribe(
      info => {
        if (info) {
          // Get them right values for credit margin
          info.forEach(
            i => {
              // Sort by date
              if (!i.credit_margin || !Array.isArray(i.credit_margin)) i.credit_margin = [];
              i.credit_margin = i.credit_margin.sort((a, b) => { return (new Date(a.date) > new Date(b.date)) ? -1 : 1 });

              let credit: number;
              if (i.credit_margin.length > 0) {
                credit = i.credit_margin[0].margin;
              } else {
                credit = 0;
              }

              i.credit = credit;
            }
          );

          this._reportService.creditManagementReport(info);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/customer/customer-list/customer-list.component.ts